<script lang="ts">
    import { Link } from "svelte-navigator";
    import ScenarioBadge from "./ScenarioBadge.svelte";
    import { ProjectDataExtensions } from "../api/projects/data/projects/ProjectDataExtensions";
    import ProjectLink from "../shared/links/ProjectLink.svelte";
    import { appManager } from "../AppManager";
    import type { ProjectAndScenariosData } from "../api/projects/data/projects/ProjectAndScenariosData";
    import Git4Icon from "../svg/Git4Icon.svelte";

    export let projectData: ProjectAndScenariosData;
    let currentUserIsAdmin = appManager.getCurrentUserAdminStore();
    let hasPublished = false;
    let url = `project/${projectData.id}`;
    let date: string = "";

    $: hasPublished = ProjectDataExtensions.hasPublished(projectData);
    $: url = `project/${projectData.id}`;
    $: if (typeof projectData !== "undefined") {
        date = formatTimestamp(projectData.lastModified ?? projectData.createdAt);
    }

    $: projectData.scenarios.sort((a, b) => {
        const aName = a.functionalName;
        const aNumber = Number(aName);
        const bName = b.functionalName;
        const bNumber = Number(bName);

        if (!isNaN(aNumber) && !isNaN(bNumber)) {
            if (aNumber < bNumber) return -1;
            return 1;
        }

        if (aName < bName) return -1;
        return 1;
    });

    const formatTimestamp = (dt: Date) => {
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };
        return dt.toLocaleString(undefined, options);
    }
</script>

<div class="col-12 col-md-6 d-flex">
    <div class="card mb-6 shadow-light-lg lift lift-lg">
        {#if hasPublished}
            <div class="status-pos">
                <status-indicator positive pulse />
            </div>
        {/if}
        <Link to={url} class="card-body">
            <h3>
                <div class="bd-highlight pt-1 min-width-name">
                    {@html projectData.name ?? ""}
                </div>
            </h3>

            <div class="mb-0 text-muted">
                {@html projectData.description ?? ""}
            </div>
        </Link>

        <a class="card-meta mt-auto" href="#!">
            <div class="my-3">
                {#each projectData.scenarios as _, i}
                    {#if i < 12}
                        <ScenarioBadge
                            project={projectData}
                            scenarioIndex={i} />
                    {/if}
                {/each}
            </div>

            <hr class="card-meta-divider mb-1" />

            <div class="avatar avatar-sm me-2">
                <Git4Icon class="project-svg" />
            </div>

            {#if $currentUserIsAdmin}
            <h6 class="text-uppercase text-muted me-2 mb-0 mw-75 project-link mw-50">
                <p class="w-100 m-0">
                    <ProjectLink {projectData}></ProjectLink> /
                </p>
                <Link to={url}>{projectData.name}</Link>
            </h6>
            {:else}
            <h6 class="text-uppercase text-muted me-2 mb-0 mw-75 project-link">
                <p class="w-100 m-0">
                    {projectData.organization.name} /
                </p>
                <Link to={url}>{projectData.name}</Link>
            </h6>
            {/if}

            <p class="h6 text-uppercase text-muted mb-0 ms-auto">
                <time datetime="{date}">{date}</time>
            </p>

        </a>
    </div>
</div>

<style>
    .project-link {
        height: 40px;
    }

    .min-width-name {
        min-width: 50%;
    }

    .status-pos {
        position: absolute;
        right: 20px;
        top: 10px;
    }
</style>
